import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { ActionIcon, Flex, Space } from '@mantine/core';

export const LBModalHeader = ({ onClose }: { onClose: () => void }) => (
  <Flex direction='column'>
    <Space h={16} />
    <ActionIcon color='gray' variant='transparent' onClick={onClose}>
      <ArrowLeftIcon width={24} />
    </ActionIcon>
    <Space h={32} />
  </Flex>
);
